// source: starlord/messages/models/user_application_assigment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_ldap_user_details_pb = require('../../../starlord/messages/models/ldap_user_details_pb.js');
goog.object.extend(proto, starlord_messages_models_ldap_user_details_pb);
goog.exportSymbol('proto.UserApplicationAssignment', null, global);
goog.exportSymbol('proto.UserApplicationAssignment.assignment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UserApplicationAssignment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UserApplicationAssignment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UserApplicationAssignment.displayName = 'proto.UserApplicationAssignment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UserApplicationAssignment.prototype.toObject = function(opt_includeInstance) {
  return proto.UserApplicationAssignment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UserApplicationAssignment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserApplicationAssignment.toObject = function(includeInstance, msg) {
  var f, obj = {
    userdetails: (f = msg.getUserdetails()) && starlord_messages_models_ldap_user_details_pb.LdapUserDetails.toObject(includeInstance, f),
    assignmenttype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UserApplicationAssignment}
 */
proto.UserApplicationAssignment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UserApplicationAssignment;
  return proto.UserApplicationAssignment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UserApplicationAssignment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UserApplicationAssignment}
 */
proto.UserApplicationAssignment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new starlord_messages_models_ldap_user_details_pb.LdapUserDetails;
      reader.readMessage(value,starlord_messages_models_ldap_user_details_pb.LdapUserDetails.deserializeBinaryFromReader);
      msg.setUserdetails(value);
      break;
    case 2:
      var value = /** @type {!proto.UserApplicationAssignment.assignment} */ (reader.readEnum());
      msg.setAssignmenttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UserApplicationAssignment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UserApplicationAssignment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UserApplicationAssignment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserApplicationAssignment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserdetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      starlord_messages_models_ldap_user_details_pb.LdapUserDetails.serializeBinaryToWriter
    );
  }
  f = message.getAssignmenttype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.UserApplicationAssignment.assignment = {
  INDIVIDUAL: 0,
  GROUP: 1
};

/**
 * optional LdapUserDetails userDetails = 1;
 * @return {?proto.LdapUserDetails}
 */
proto.UserApplicationAssignment.prototype.getUserdetails = function() {
  return /** @type{?proto.LdapUserDetails} */ (
    jspb.Message.getWrapperField(this, starlord_messages_models_ldap_user_details_pb.LdapUserDetails, 1));
};


/**
 * @param {?proto.LdapUserDetails|undefined} value
 * @return {!proto.UserApplicationAssignment} returns this
*/
proto.UserApplicationAssignment.prototype.setUserdetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UserApplicationAssignment} returns this
 */
proto.UserApplicationAssignment.prototype.clearUserdetails = function() {
  return this.setUserdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UserApplicationAssignment.prototype.hasUserdetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional assignment assignmentType = 2;
 * @return {!proto.UserApplicationAssignment.assignment}
 */
proto.UserApplicationAssignment.prototype.getAssignmenttype = function() {
  return /** @type {!proto.UserApplicationAssignment.assignment} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.UserApplicationAssignment.assignment} value
 * @return {!proto.UserApplicationAssignment} returns this
 */
proto.UserApplicationAssignment.prototype.setAssignmenttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto);
